export default () => ({
  includes: [],
  pagination: {},
  defaultSearch: {
    limit: 6,
    page: 1,
    pagination: true
  },
  search: {
  }
})



// WEBPACK FOOTER //
// ./src/crud/index/resources/data.js